import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { Loader2 } from "lucide-react";

export default function RequireAuth({ children }) {
  const { user, authLoading } = useApp();
  const location = useLocation();
  if (authLoading) {
    return (
      <div className="min-h-[50vh] grid place-items-center">
        <Loader2 className="w-8 h-8 animate-spin" style={{ color: "var(--amd-primary)" }} />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ next: location.pathname + location.search }} />;
  return children;
}
